var map = {
	"./CardContainerMultiColumnExtensions": 85098,
	"./CardContainerMultiColumnExtensions.ts": 85098,
	"./CustomerCardExtensions": 82046,
	"./CustomerCardExtensions.ts": 82046,
	"./ManageShareListModalExtensions": 55419,
	"./ManageShareListModalExtensions.tsx": 55419,
	"./OrderUploadErrorsModalExtensions": 24183,
	"./OrderUploadErrorsModalExtensions.ts": 24183,
	"./OrderUploadExtensions": 68797,
	"./OrderUploadExtensions.ts": 68797,
	"./ProductPriceExtensions": 70322,
	"./ProductPriceExtensions.ts": 70322,
	"./ProductSelectorVariantModalExtensions": 5503,
	"./ProductSelectorVariantModalExtensions.ts": 5503,
	"./README.md": 76632,
	"./ScheduleReminderModalExtensions": 53722,
	"./ScheduleReminderModalExtensions.ts": 53722,
	"./TwoButtonModalExtensions": 61791,
	"./TwoButtonModalExtensions.ts": 61791,
	"./WishListCardExtensions": 90122,
	"./WishListCardExtensions.ts": 90122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7989;